import React from "react";

import {
  DIRECT_LABOR_STATIC_COLUMNS,
  WEEKLY_BUCKET_COLUMN_WIDTHS,
  WEEKLY_COLUMN_WIDTH,
} from "./weeklyEACColumns";
import { formatCellValue } from "./weeklyEACFormat";
import { getBucketForWeek } from "./weeklyEACCalculations";
import WeeklyEACDirectLaborWeeklyTotalRow from "./WeeklyEACDirectLaborWeeklyTotalRow";

export default function WeeklyEACDirectLaborWeeklyTable({
  employeeDetails,
  allEmployeeDetails,
  weekColumns,
  type,
  isEdit,
  onHoursChange,
}) {
  const staticColumns = DIRECT_LABOR_STATIC_COLUMNS.filter(
    (column) => column.hideForType !== type,
  );

  return (
    <table className="secondTableFin weeklyEac" cellPadding={0} cellSpacing={0}>
      <thead>
        <tr>
          {staticColumns.map((column) => (
            <th
              key={column.label}
              rowSpan={2}
              style={{
                minWidth: column.width[type],
                maxWidth: column.width[type],
              }}
            >
              {column.label}
            </th>
          ))}
          {weekColumns.map((week, index) => (
            <th
              key={week.weekStartDate}
              colSpan={3}
              className="centerAlignedHeaderLeftBorder"
              style={{
                minWidth: WEEKLY_COLUMN_WIDTH,
                maxWidth: WEEKLY_COLUMN_WIDTH,
                ...(index === weekColumns.length - 1
                  ? { borderRight: "1px solid #fff" }
                  : {}),
              }}
            >
              {formatCellValue(week.weekEndDate, "date")}
            </th>
          ))}
        </tr>
        <tr>
          {weekColumns.map((week, index) => {
            const headerClass =
              week.type === "Actual"
                ? "actualHeaderCost"
                : "forecastHeaderCost";
            const isLastWeek = index === weekColumns.length - 1;
            return (
              <React.Fragment key={week.weekStartDate}>
                <th
                  className={headerClass}
                  style={{
                    minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.costRate,
                    maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.costRate,
                  }}
                >
                  Eff. Cost Rate (Loaded)
                </th>
                <th
                  className={headerClass}
                  style={{
                    minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.hours,
                    maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.hours,
                  }}
                >
                  Hours
                </th>
                <th
                  className={headerClass}
                  style={{
                    minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                    maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                    ...(isLastWeek ? { borderRight: "1px solid #ccc" } : {}),
                  }}
                >
                  Burden Cost
                </th>
              </React.Fragment>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {employeeDetails.map((employee) => (
          <tr key={employee.dlId}>
            {staticColumns.map((column) => (
              <td
                key={column.label}
                style={{
                  minWidth: column.width[type],
                  maxWidth: column.width[type],
                }}
                title={formatCellValue(column.accessor(employee), column.format)}
              >
                {formatCellValue(column.accessor(employee), column.format)}
              </td>
            ))}
            {weekColumns.map((week, index) => {
              const bucket = getBucketForWeek(employee, week.weekStartDate);
              const editableHours = isEdit && bucket?.type === "Forecast";
              const isLastWeek = index === weekColumns.length - 1;
              return (
                <React.Fragment key={week.weekStartDate}>
                  <td
                    style={{
                      minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.costRate,
                      maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.costRate,
                      borderLeft: "1px solid #ccc",
                      paddingLeft: "4px",
                    }}
                    title={formatCellValue(bucket?.costRateLoaded, "currency")}
                  >
                    {formatCellValue(bucket?.costRateLoaded, "currency")}
                  </td>
                  <td
                    style={{
                      minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.hours,
                      maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.hours,
                    }}
                    title={String(bucket?.hours ?? "")}
                  >
                    {editableHours ? (
                      <input
                        type="number"
                        value={bucket?.hours ?? ""}
                        style={{ width: "60px" }}
                        onChange={(e) =>
                          onHoursChange(
                            employee.dlId,
                            week.weekStartDate,
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      (bucket?.hours ?? "")
                    )}
                  </td>
                  <td
                    style={{
                      minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                      maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                      ...(isLastWeek ? { borderRight: "1px solid #ccc" } : {}),
                    }}
                    title={formatCellValue(bucket?.burdenCost, "currency")}
                  >
                    {formatCellValue(bucket?.burdenCost, "currency")}
                  </td>
                </React.Fragment>
              );
            })}
          </tr>
        ))}
        <WeeklyEACDirectLaborWeeklyTotalRow
          employeeDetails={allEmployeeDetails}
          weekColumns={weekColumns}
          staticColumns={staticColumns}
          type={type}
        />
      </tbody>
    </table>
  );
}
